export enum TestOrderDataModAction {
  STATUS_CHANGE = 'STATUS_CHANGE',
  CONTAINER_CHANGE = 'CONTAINER_CHANGE',
}
